module.exports = __webpack_public_path__ + "static/media/SD__CI_ANTIGUA_VF.0bd03238.png";